import AppView from "./App.view";
import { IAppRouterProps } from "./AppRouter/AppRouter.types";
import { IAuthStore } from "../redux/authReducer/types";
import { INavBarProps } from "./NavBar/NavBar.types";
import { message } from "antd";
import React from "react";
import SessionService from "../services/SessionService";
import VoiceGainAuthSvcApi from "../apis/VoiceGainAuthSvcApi";

interface IProps {
  isLoggedIn: IAuthStore["isLoggedIn"];
  logOut: () => any;
}

interface IState {
  isProcessingLogOut: boolean;
}

class AppContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { isProcessingLogOut: false };
  }

  public render = () => {
    const appRouterProps: IAppRouterProps = {
      isLoggedIn: this.props.isLoggedIn
    };
    const navBarProps: INavBarProps = {
      isLoggedIn: this.props.isLoggedIn,
      onClickLogOut: () =>
        this.setState({ isProcessingLogOut: true }, () =>
          VoiceGainAuthSvcApi.logOut().finally(() =>
            SessionService.clearSession()
              .then(() => this.props.logOut())
              .then(() => {
                message.success("Logged out");
              })
              .finally(() => this.setState({ isProcessingLogOut: false }))
          )
        )
    };
    return (
      <AppView
        appRouterProps={appRouterProps}
        isSpinningAppRouter={this.state.isProcessingLogOut}
        navBarProps={navBarProps}
      />
    );
  };
}

export default AppContainer;
